export default __webpack_public_path__ + "static/media/button-background.65d027a0.png";